import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { decodeImpersonationPayload } from '../utils/impersonationToken';

const ImpersonateBridgePage = () => {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [error, setError] = useState('');

  useEffect(() => {
    const hash = window.location.hash.slice(1);
    if (!hash) {
      setError('Geçersiz bağlantı.');
      return;
    }

    try {
      const data = decodeImpersonationPayload(hash);
      if (!data?.token) {
        setError('Geçersiz bağlantı.');
        return;
      }

      login(data);
      sessionStorage.setItem('impersonation_active', '1');
      sessionStorage.setItem('impersonation_name', [data.name, data.surname].filter(Boolean).join(' '));

      // Token URL'de kalmasın diye hash hemen temizlenir.
      window.history.replaceState(null, '', window.location.pathname);
      navigate('/panel', { replace: true });
    } catch {
      setError('Bağlantı okunamadı.');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (error) {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '60vh', gap: '16px' }}>
        <p style={{ color: '#DC2626', fontSize: '15px' }}>{error}</p>
        <button
          onClick={() => navigate('/', { replace: true })}
          style={{ padding: '10px 24px', borderRadius: '9999px', background: '#2F3A8F', color: '#fff', border: 'none', cursor: 'pointer', fontSize: '14px' }}
        >
          Ana Sayfaya Dön
        </button>
      </div>
    );
  }

  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '60vh' }}>
      <p style={{ color: '#475569', fontSize: '15px' }}>Giriş yapılıyor...</p>
    </div>
  );
};

export default ImpersonateBridgePage;
